import React, {useRef} from "react";
import Translate from "../../../../../../../../../components/Translate";
import Input from "../../../../../../../../../components-new/form/Input";
import config from "../../../../../../../../../config";
import AiBlock from "./AiBlock";

const AiNumberSetting = ({
                             titleKey,
                             labelKey,
                             aiType,
                             value,
                             setValue,
                             updateFunction,
                             client,
                             addNotification,
                             min,
                             max
                         }) => {

    const lastSavedValue = useRef(value);

    function handleBlur(e) {
        var v = e.target.value;

        if (v.trim() === "" || v === lastSavedValue.current) return;

        updateFunction(client.id, v)
            .then(function () {
                setValue(v);
                lastSavedValue.current = v;
                addNotification("successful", config.notificationLevels.success);
            })
            .catch(function () {
                addNotification("somethingWentWrong", config.notificationLevels.error);
            });
    }

    function validate(value) {
        const isValid = value >= min && value <= max;
        if (!isValid) {
            throw new Error('Wrong Format');
        }
    }

    // after the hook on purpose: an earlier return would change the number of
    // hooks between renders and React fails the screen when the type changes
    if (aiType !== config.AITypes.GPT_AI && aiType !== config.AITypes.GEMINI_AI
        && aiType !== config.AITypes.TEAM_AI && aiType !== config.AITypes.TEAM_AI_TEST) return null;

    return (
        <AiBlock titleKey={titleKey} hintKey={labelKey}>
            <div className="ai-number">
                <Input
                    validate={validate}
                    min={min}
                    max={max}
                    style={{width: '110px'}}
                    type={'number'}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onBlur={handleBlur}
                />
                <span className="ai-number__suffix">
                    <Translate text="hours"/> ({min}–{max})
                </span>
            </div>
        </AiBlock>
    );
};

export default AiNumberSetting;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/AI/AiNumberSetting.jsx